import { render, staticRenderFns } from "./SlaDashboard.vue?vue&type=template&id=a1b3a58a&scoped=true&"
import script from "./SlaDashboard.vue?vue&type=script&lang=js&"
export * from "./SlaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b3a58a",
  null
  
)

export default component.exports